import store from '@/store';
import JwtService from '@/common/jwt.service';
import ApiService from '@/common/api.service';

export default {
    storeToken(response) {
        const auth = store.state.auth;

        JwtService.saveToken(response.data.token);
        JwtService.saveRefreshToken(response.data.refreshToken);
        ApiService.setJwtHeader();

        auth.isLoggedIn = true;
        auth.accessToken = response.data.token;
        // auth.refreshToken = response.data.refreshToken;
        auth.friendlyUsername = response.data.friendlyUsername;

        auth.role = response.data.role;

        if (response.data.role) {
            let authority = 'STANDARD_ROLE';
            if (response.data.role === 1) {
                authority = 'ADMIN_ROLE';
            }
            if (response.data.role === 2) {
                authority = 'STANDARD_ROLE';
            }
            if (response.data.role === 3) {
                authority = 'USERADMIN_ROLE';
            }
            auth.authorities = [authority];
        }
        auth.userId = response.data.userId;
        auth.department = response.data.department;
        auth.auswertung = response.data.auswertung;
        store.dispatch('auth/update', auth);
        store.dispatch('account/get', auth.userId);
    },
    store2FaToken(response) {
        const auth = store.state.auth;

        JwtService.saveToken(response.data.token);
        JwtService.saveRefreshToken(response.data.refreshToken);
        ApiService.setJwtHeader();
        auth.isLoggedIn = false;
        auth.userId = response.data.userId;
        store.dispatch('auth/update', auth);
    },
};
